import React from "react";

// سمپل
export class Template extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      InvalidFields: []
    };
    this.props.NextBtn(false);
  }


  // noinspection DuplicatedCode
  ValidateField = e => {
    const INVALID_FIELDS = this.state.InvalidFields;
    if (e.target.value === "" || e.target.value === 0) {
      INVALID_FIELDS.push(e.target.name);
    } else if (INVALID_FIELDS.includes(e.target.name)) {
      const NAME = e.target.name;
      const INDEX = INVALID_FIELDS.indexOf(NAME);
      INVALID_FIELDS.splice(INDEX, 1);
    }
    this.setState({
      InvalidFields: INVALID_FIELDS
    });

    this.props.NextBtn(this.state.InvalidFields.length === 0);
  }

  Require = (FieldName) => {
    return {
      onBlur: this.ValidateField,
      error: this.state.InvalidFields.includes(FieldName)
    }
  }

  ChangeHandler = (e) => this.setState({ [e.target.name]: e.target.value });

  render() {
    return (
      <div className="row">
        <div className="col-12">

        </div>
      </div>
    );
  }
}


export const FormTemplate = props => <div className="row mt-3 w-100">
  <div className="col-12">
    {props.children}
  </div>
</div>
export default FormTemplate;
